import { useStytch } from "@stytch/react";
import { Button } from "@/components/ui/button";    
import GoogleLogo from "@/components/svg/GoogleLogo";
import DiscordLogo from "@/components/svg/DiscordLogo";
import TwitterLogo from "@/components/svg/TwitterLogo";
import YahooLogo from "@/components/svg/YahooLogo";
import AppleLogo from "@/components/svg/AppleLogo";
import { getHost } from "@/lib/utils";
import FacebookLogo from "@/components/svg/FacebookLogo";
import HybridTooltip from "@/components/ui/hybrid-tooltip";
import type { OAuthProviders } from "@/types";

interface OauthProps  {
    rid: string | null;
    username: string | null;
}

const OAuthButtons = ({ rid, username }: OauthProps) => {
    const stytch = useStytch();
    let redirectOauthUrl = `https://${getHost(window.location.href)}?rid=${
      rid || ""
    }`;
  
    if (username) {
      redirectOauthUrl += `&username=${username}`;
    }
  
    const startOAuth = (provider: OAuthProviders) => {
      switch (provider) {
        case "google":
          return stytch.oauth.google.start({
            login_redirect_url: redirectOauthUrl,
            signup_redirect_url: redirectOauthUrl,
          });
        case "discord":
          return stytch.oauth.discord.start({
            login_redirect_url: redirectOauthUrl,
            signup_redirect_url: redirectOauthUrl,
          });
        case "yahoo":
          return stytch.oauth.yahoo.start({
            login_redirect_url: redirectOauthUrl,
            signup_redirect_url: redirectOauthUrl,
          });
        case "twitter":
          return window.location.replace(
            `https://${
              import.meta.env.MODE === "development" ? "test" : "api"
            }.stytch.com/v1/public/oauth/twitter/start?public_token=${
              import.meta.env.VITE_STYTCH_PUBLIC_TOKEN
            }&login_redirect_url=${redirectOauthUrl}&signup_redirect_url=${redirectOauthUrl}`
          );
        case "apple":
          return stytch.oauth.apple.start({
            login_redirect_url: redirectOauthUrl,
            signup_redirect_url: redirectOauthUrl,
          });
        default:
          return;
      }
    };
  
    return (
      <div className="space-y-2.5">
        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => startOAuth("google")}
        >
          <GoogleLogo />
          Continue with Google
        </Button>
        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => startOAuth("discord")}
        >
          <DiscordLogo />
          Continue with Discord
        </Button>
        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => startOAuth("twitter")}
        >
          <TwitterLogo />
          Continue with Twitter
        </Button>
        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => startOAuth("yahoo")}
        >
          <YahooLogo />
          Continue with Yahoo
        </Button>
        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => startOAuth("apple")}
        >
          <AppleLogo />
          Continue with Apple
        </Button>


        <HybridTooltip
          className="w-full"
          content={
            <span>
              Facebook login has been removed. If you've had an account using that login, 
              <br />
              please email us at <a href="mailto:contact@getcollectr.com" className="underline underline-offset-2 text-sky-500 font-bold" target="_blank" rel="noreferrer noopener">contact@getcollectr.com</a> and we'll migrate your account!
            </span>
          }
        >
          <Button 
            variant="outline" 
            onClick={() => startOAuth("facebook")}
            className="w-full"
            disabled
          >
            <FacebookLogo />
            Continue with Facebook
          </Button>
        </HybridTooltip>
      </div>
    );
  };

  export default OAuthButtons